import { normalizeCatalogLanguage } from "@lorevok/domain";

/**
 * A language code as a name in the reader's interface language ("ru" →
 * "Русский" for a Russian UI, "Russian" for an English one); the code itself,
 * upper-cased, when the browser can't name it.
 */
export function languageName(code: string, uiLang: string): string {
  try {
    const name = new Intl.DisplayNames([uiLang], { type: "language" }).of(code);
    if (name && name !== code) return name.charAt(0).toLocaleUpperCase(uiLang) + name.slice(1);
  } catch {
    // Unknown locale or code — fall through to the bare code.
  }
  return code.toUpperCase();
}

/** A novel's language as a card chip: its primary subtag, upper-cased ("pt-BR" → "PT"); null when unreadable. */
export function languageChipCode(code: string | null | undefined): string | null {
  return normalizeCatalogLanguage(code)?.toUpperCase() ?? null;
}
